/**
 * The price a customer pays for a single package once a promotional offer coupon
 * is applied — for display of a struck-through "was / now" price on the pricelist.
 *
 * PERCENTAGE ONLY, on purpose. The server's Coupon.calculate_discount PERCENTAGE
 * branch is `cart.price * (value / 100)`, which is linear, so a per-package
 * percentage shown here matches what checkout charges to the cent. Every other
 * coupon type (flat, percentage+flat, volume, free-shipping) is an order-level or
 * conditional amount with no honest per-card equivalent — for those this returns
 * null and the card shows only its regular price; the offer still rides through
 * the banner and the checkout Discount line.
 *
 * Keep this the ONLY place the client computes a discounted price. If you find
 * yourself replicating a coupon calculation elsewhere, call this instead — the
 * one-implementation rule is exactly what kept the two server discount paths from
 * drifting, and it applies on the client too.
 *
 * @param {number|string} price  regular package price
 * @param {object|null} coupon   resolved offer coupon ({ couponType, value })
 * @returns {number|null} discounted price (>= 0), or null if not displayable per-card
 */
export default function discountedPrice(price, coupon) {
  if (!coupon || coupon.couponType !== 'PERCENTAGE') return null;

  const base = Number(price);
  const pct = Number(coupon.value);
  if (Number.isNaN(base) || Number.isNaN(pct) || pct <= 0) return null;

  return Math.max(0, base * (1 - pct / 100));
}
